import {getMessages} from 'app/store/constants';

export const BOARD_IMPORT_TITLE = getMessages().getText('board_settings.board_import.title');
export const BOARD_IMPORT_DESCRIPTION = getMessages().getText('board_settings.board_import.description');
export const BOARD_IMPORT_MORE_INSTRUCTIONS = getMessages().getText('board_settings.board_import.more_instructions');
export const BOARD_IMPORT_FAQ = getMessages().getText('board_settings.board_import.faq');
export const BOARD_IMPORT_FAQ_LINK = getMessages().getText('board_settings.board_import.faq_link');
